<template>
  <el-container class="home">
    <!--头部-->
    <el-header class="ub main-justify cross-center header">
      <div class="hearder-left">
        <img src="../assets/images/logo.png" alt="" />
        <!-- <img v-else :src="require('../assets/images/logo_'+companyType+'.png')" alt="" /> -->
        <div class="header-left-text">锦辉物联发电管理平台<strong style="color:red">V1.0</strong></div>
        <!-- <div class="header-menu-path">{{ menuPath }}</div> -->
      </div>
      <div class="ub main-center cross-center">
        <img class="user-img" src="../assets/images/avatar.jpg" />
        <div class="user-role">
          <div class="wellcom">欢迎你,{{ user }}</div>
          <!-- <div class="header-time">2020.7.29 15:53:49 星期三</div> -->
        </div>
        <el-dropdown placement="bottom-start">
          <div class="hearder-icon iconfont icon-drop-down"></div>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item @click.native="changePw()"
              >修改密码</el-dropdown-item
            >
            <el-dropdown-item @click.native="logout()"
              >退出账号</el-dropdown-item
            >
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </el-header>
    <el-container>
      <!--菜单栏-->
      <el-aside
        width="200px"
        style="margin-right:0"
        :class="[isCollapse ? 'w80' : 'w200']"
      >
        <menu-bar></menu-bar>
      </el-aside>
      <!--右边显示区域-->
      <el-container>
        <el-main style="padding:0;position:relative">
          <!--菜单收缩按钮
          <i
            class="arrowIcon"
            :class="[isCollapse ? 'el-icon-s-unfold' : 'el-icon-s-fold']"
            @click="iconClick"
          ></i>-->
          <router-view :key="$route.path + $route.query.t"></router-view>
          <alarm-form v-if="hasPerm('warn:remind:set:query')"></alarm-form>
        </el-main>
        <!--<el-footer style="background: orange;">Footer</el-footer>-->
      </el-container>
    </el-container>
    <el-dialog
      title="修改密码"
      :visible.sync="changePasswordVisible"
      class="password-dialog"
    >
      <el-form
        ref="passwordForm"
        :model="passwordForm"
        size="mini"
        :inline="true"
      >
        <el-form-item prop="user" label="账号">
          <el-input type="text" v-model="user" disabled=""></el-input>
        </el-form-item>
        <el-form-item prop="oldPassword" label="原密码">
          <el-input
            type="password"
            v-model="passwordForm.oldPassword"
            placeholder="请输入"
          ></el-input>
        </el-form-item>
        <el-form-item prop="newPassword" label="新密码">
          <el-input
            type="password"
            v-model="passwordForm.newPassword"
            placeholder="请输入"
          ></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="changePasswordVisible = false">取 消</el-button>
        <el-button type="primary" @click="saveOrUpdate">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 更新公告详情 -->
    <el-dialog
      :title="noticeDetail.title"
      :show-close="false"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :visible.sync="noticeSwitch"
      width="600px"
      center
      class="noticeSwitch"
      >
      <div>{{userNotice}}</div>
      <div v-for="(item,index) in noticeDetail.contentList" :key="index" style="text-indent:25px">
        {{item}}
      </div>
      <div>{{sorry}}</div>
      <p style="text-align:right">杭州锦辉科技有限公司</p>
      <p style="text-align:right">{{noticeDetail.releaseTime}}</p>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="noticeSwitchBtn"
          >已知晓</el-button
        >
      </span>
    </el-dialog>
  </el-container>
</template>

<script>
// @ is an alias to /src
//import HelloWorld from '@/components/HelloWorld.vue'
import MenuBar from "@/components/MenuBar.vue"
import AlarmForm from "@/components/AlarmForm.vue"
import { mapState } from "vuex"
export default {
  name: "Home",
  components: {
    MenuBar,
    AlarmForm,
  },
  computed: {
    ...mapState({
      isCollapse: (state) => state.MenuStore.isCollapse,
      menuPath: (state) => state.MenuStore.menu_path,
    }),
  },
  data() {
    return {
      user: "",
      companyType:1,
      noticeDetail:[],
      userNotice:null,
      sorry:null,
      noticeSwitch: false,
      passwordForm: {},
      changePasswordVisible: false,
    }
  },
  mounted() {
    this.user = sessionStorage.getItem("user")
    this.companyType = sessionStorage.getItem("companyType")
    if(sessionStorage.getItem("noticeSwitch") == 1){
      this.noticeDetailBtn()
    }
  },
  methods: {
    // 查看公告详情
    async noticeDetailBtn(){
      let _this = this
      let { data: res } = await _this.$axios.get(`/api/notice/announcement/1`)
      if (res.code == 1) {
        _this.userNotice=res.data.contentList.splice(0,1)[0]
        _this.sorry=res.data.contentList.splice(-1,1)[0]
        _this.noticeDetail=res.data
        _this.noticeSwitch=true
      } else {
        _this.$message.warning(res.msg)
      }
    },
    noticeSwitchBtn(){
      this.noticeSwitch=false
      sessionStorage.setItem("noticeSwitch",2)
    },
    async logout() {
      let { data: res } = await this.$axios.get("api/sys/logout")
      if (res.code == 1) {
        sessionStorage.clear()
        window.location.href = "/login"
      }
    },
    changePw() {
      this.$resetForm(this, "passwordForm")
      this.changePasswordVisible = true
    },
    async saveOrUpdate() {
      let _this = this
      let { data: res } = await _this.$axios.patch(
        "/api/sys/user/password",
        _this.passwordForm
      )
      if (res.code == 1) {
        _this.changePasswordVisible = false
        _this.$resetForm(_this, "passwordForm")
        _this.$message.success("操作成功")
        _this.logout()
      } else {
        _this.$message.warning(res.msg)
      }
    },
    iconClick() {
      this.$store.commit("setOpenOrClose")
    },
    // showUser () {
    //   this.user = sessionStorage.getItem("user")
    // },
  },
}
</script>
<style lang="scss" scoped>
html,
body {
  height: 100%;
}
.el-header + .el-container {
  height: calc(100% - 60px);
}
.el-header {
  padding: 0 14px;
}
#app .home {
  min-width: 1280px !important;
  min-height: 756px !important;
}
.el-tabs__header {
  position: static !important;
}
.home {
  height: 100%;
}
.header {
  background-color: #e9e9e9;
  color: #fff;
}
.hearder-left {
  position: relative;
}
.hearder-left {
  img {
    // width: 28px;
    height: 35px;
    margin-right:10px;
    float: left;
    // position: absolute;
    // top: 5px;
    // left: 0;
  }
}
.header-left-text {
  float: left;
  // padding-left: 36px;
  line-height: 36px;
  font-size: 18px;
  color:#333;
}
.header-menu-path {
  float: left;
  padding-left: 40px;
  line-height: 37px;
  font-size: 14px;
}
.user-img {
  width: 45px;
  height: 45px;
  border-radius: 50%;
  cursor: pointer;
}
.user-role {
  margin-left: 10px;
}
.wellcom {
  font-size: 15px;
  font-weight: bolder;
  color:#333;
}
.header-time {
  font-size: 14px;
}
.hearder-icon {
  width: 16px;
  height: 20px;
  text-align: center;
  line-height: 20px;
  margin: 0 10px;
  font-size: 10px;
  color: #333;
  cursor: pointer;
}
.arrowIcon {
  font-size: 20px;
  float: left;
  height: 20px;
  width: 20px;
  position: absolute;
  left: 0;
  top: 0;
  text-align: center;
  line-height: 20px;
}
.w200 {
  width: 200px !important;
}
.w80 {
  width: 80px !important;
}
//修改密码
.password-dialog /deep/ .el-dialog {
  width: 600px;
}
.password-dialog /deep/ .el-form-item__label {
  width: 140px;
  height: 32px;
  margin-left: 20px;
  text-align: left;
  color: #343434;
  font-size: 14px;
}
.password-dialog /deep/ .el-form-item__content {
  width: 360px;
  height: auto;
}
.password-dialog /deep/ .el-form-item__content {
  width: 360px;
}
.password-dialog /deep/ .el-date-editor.el-input {
  width: 360px;
}
.noticeSwitch{
  line-height: 30px;
}
</style>
